import styled from 'styled-components';

const StyledBackButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 5px;
	cursor: pointer;
	transition: background-color 0.3s ease;

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(1);
		}
	}

	img {
		width: 10px;
		height: 10px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}
`;

export { StyledBackButton };
